import { SearchResultDt, SearchResultItemDt } from "../../Models/SearchModel";

export const textSearch = async (searchText: string): Promise<SearchResultDt> => {
    const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;
    try {
      const response = await fetch(
        `${apiUrl}Search/FreeText?phrase=${searchText}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const data: SearchResultDt = await response.json();
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      return {
        phrase: "",
        category: "",
        filters: {
          sectorCategories: [],
          useCategories: [],
          alternativeLevels: [],
          alternativeToCategories: [],
          certificationsCategories: [],
          suppliers: [],
        },
        items: [],
      };
    }
  };

  export const alternativeToSearch = async (id: number): Promise<SearchResultDt> => {
    const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;
    try {
      const response = await fetch(
        `${apiUrl}Search/AlternativeTo?id=${id}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const data: SearchResultDt = await response.json();
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      return {
        phrase: "",
        category: "",
        filters: {
          sectorCategories: [],
          useCategories: [],
          alternativeLevels: [],
          alternativeToCategories: [],
          certificationsCategories: [],
          suppliers: [],
        },
        items: [],
      };
    }
  };

  export const SectorSearch = async (id: number): Promise<SearchResultDt> => {
    const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;
    try {
      const response = await fetch(
        `${apiUrl}Search/Sector?id=${id}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const data: SearchResultDt = await response.json();
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      return {
        phrase: "",
        category: "",
        filters: {
          sectorCategories: [],
          useCategories: [],
          alternativeLevels: [],
          alternativeToCategories: [],
          certificationsCategories: [],
          suppliers: [],
        },
        items: [],
      };
    }
  };

  export const useSearch = async (id: number): Promise<SearchResultDt> => {
    const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;
    try {
      const response = await fetch(
        `${apiUrl}Search/Use?id=${id}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const data: SearchResultDt = await response.json();
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      return {
        phrase: "",
        category: "",
        filters: {
          sectorCategories: [],
          useCategories: [],
          alternativeLevels: [],
          alternativeToCategories: [],
          certificationsCategories: [],
          suppliers: [],
        },
        items: [],
      };
    }
  };

  export const myAds = async (): Promise<SearchResultItemDt[]> => {
    const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;
    try {
      const response = await fetch(
        `${apiUrl}Search/MyAlternatives`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const data: SearchResultItemDt[] = await response.json();
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      return [] as SearchResultItemDt[];
    }
  };

  export const notPublished = async (): Promise<SearchResultItemDt[]> => {
    const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;
    try {
      const response = await fetch(
        `${apiUrl}Search/NotPublished`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const data: SearchResultItemDt[] = await response.json();
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      return [] as SearchResultItemDt[];
    }
  };

  export const searchByGroups = async (ids: number[]): Promise<SearchResultDt> => {
    const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;
    try {
      const queryParams = ids.map(id => `id=${id}`).join('&');
      const response = await fetch(
        `${apiUrl}Search/Groups?${queryParams}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const data: SearchResultDt = await response.json();
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      return {
        phrase: "",
        category: "",
        filters: {
          sectorCategories: [],
          useCategories: [],
          alternativeLevels: [],
          alternativeToCategories: [],
          certificationsCategories: [],
          suppliers: [],
        },
        items: [],
      };
    }
  };

  export const searchByCas = async (cas: string): Promise<SearchResultDt> => {
    const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;
    try {
      const response = await fetch(
        `${apiUrl}Search/Cas?cas=${encodeURIComponent(cas)}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const data: SearchResultDt = await response.json();
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      return {
        phrase: "",
        category: "",
        filters: {
          sectorCategories: [],
          useCategories: [],
          alternativeLevels: [],
          alternativeToCategories: [],
          certificationsCategories: [],
          suppliers: [],
        },
        items: [],
      };
    }
  };

  export const searchByChemical = async (sessionId?: string): Promise<SearchResultDt> => {
    const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;
    try {
      let url = `${apiUrl}Search/Chemical`;
      if (sessionId) {
        url += `?sessionId=${encodeURIComponent(sessionId)}`;
      }
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const data: SearchResultDt = await response.json();
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      return {
        phrase: "",
        category: "",
        filters: {
          sectorCategories: [],
          useCategories: [],
          alternativeLevels: [],
          alternativeToCategories: [],
          certificationsCategories: [],
          suppliers: [],
        },
        items: [],
      };
    }
  };